module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.209f7259.svg#twitter-usage",
      toString: function () {
        return this.url;
      }
    }